'use strict';

require('angular');

module.exports = angular
    .module('widgets.user', [])
    .directive('fcLogin', require('./login'))
    .directive('fcMe', require('./me'))
    .directive('fcUser', require('./user'));
